export default "__VITE_ASSET__CotL1rGJ__"